import React from "react";

interface AppLoaderProps {
  text?: string;
}

const AppLoader: React.FC<AppLoaderProps> = ({ text = "Loading..." }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        backgroundColor: "white",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            display: "flex",
            gap: "8px",
            justifyContent: "center",
            marginBottom: "24px",
          }}
        >
          {[0, 0.15, 0.3].map((delay, i) => (
            <div
              key={i}
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                backgroundColor: "#756DE9",
                animation: `bounce 1.4s ease-in-out infinite both ${delay}s`,
              }}
            />
          ))}
        </div>
        <h2
          style={{
            color: "lightgray",
            fontWeight: 300,
            fontSize: "24px",
            margin: 0,
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          {text}
        </h2>
      </div>
    </div>
  );
};

export default AppLoader;

